export enum gaEventTypes {
  click = "click",
  page_view = "page_view",
  event = "event",
  hover = "hover",
}
export enum gaBrandNames {
  reach = "Reach",
  wow = "Wow",
  brand = "Brand",
  ghost = "Ghost",
}
export enum gaScreenNames {
  home = "Home",
  phones = "Phones",
  plan = "Plan",
  bestFit = "bestfit",
  contactUs = "Contact Us",
  BillCalculator = "Bill Calculator",
  coverageCheck = "Coverage Check",
  giveBack = "Give Back",
  internationalServices = "International Services",
  trackOrder = "Track Order",
  imeiCompatibilityCheck = "imei_compatability_checked",
  imeicheck= "imei_check_skipped",
  login = "Login",
  signup = "signup",
  discover = "Discover",
  aboutUs = "About Us",
  privacy = "Privacy",
  activation = "Activation",
  checkout = "proceed_to_checkout",
  helpCenter = "helpCenter",
  help = "help",
  postActivationHome = "postActivationHome",
  account = "account",
  billing = "Billing",
  profile = "profile",
  reviews = "reviews",
  services = "services",
  terms = "terms",
  secondaryUserHome = "secondaryUserHome",
  activateEsim = "ActivateEsim",
  settings = "settings",
  wallet = "wallet",
  ulTerms = "UlTerms",
  paymentLanding="PaymentLanding",
  simType = "sim_type_selected",
  phonedetails = "phone_details_confirmed",
  activationInitiated = "activation_initiated",
  act_sim_type = "activation_sim_type_confirmed",
  numPrefSel = "number_preference_selected",
  portinInitiated= "portin_initiated",
  zipCompleted = "zip_code_check_completed",
  port_submited = "portin_details_submited",
}
export enum gaCategory {
  leadGeneration = "generate_lead",
  checkCoverage = "coverage_check",
  imeiCheck = "IMEI_check",
  plan = "plans",
  lineSelection = "line_selection",
  data = "data",
  brandFeatures = "brand_features",
  networkCompatible = "network_compatible",
  phones = "phones",
  comparePlans = "compare_phone_plans",
  phoneCompatibility = "phone_compatibility",
  helpSupport = "help_support",
  help = "help",
  detailCoverage = "detail_coverage",
  billCalculator = "bill_calculator",
  meetTheRecipients = "meet_the_recipients",
  internationalServices = "international_services",
  activation = "activation",
  networkCoverage = "network_coverage",
  bestFit = "bestfit",
  CheckCompatibility = "compatibility_check",
  whereWeGive = "where_we_give",
  footer = "footer",
  login = "login",
  signup = "click_signup",
  forgotPassword = "click_forgot_password",
  primaryValues = "primary_values",
  discover = "discover",
  share = "share",
  privacy = "privacy",
  support = "support",
  swiftPurchase = "swift_purchase",
  purchaseFlow = "purchase_flow",
  userStories = "user_stories",
  donations = "donations",
  dataUsage = "data_usage",
  manageLines = "manage_lines",
  paymentHistory = "payment_history",
  detailedPaymentHistory = "detailed_payment_history",
  autoPaymentDetails = "auto_payment_details",
  currentPlan = "current_plan",
  changePlan = "change_plan",
  buyDataPack = "buy_data_pack",
  editProfile = "edit_profile",
  ourPartners = "our_partners",
  wallet = "wallet",
  purchaseInitiated = "proceed_to_payment",
  planCardSelected = "plan_selected",
  puchaseFailed = "payment_failed",
  puchaseSuccess = "payment_successful",
}
